<template>
  <div class="employees-container">
    <div class="employees-tree" v-if="!this.userInfo.storeId">
      <el-tree class="el-tree"
               v-loading="loading"
               ref="treeRef"
               node-key="id"
               :default-expand-all="true"
               :highlight-current='true'
               :current-node-key="currentKey"
               :expand-on-click-node="false"
               :data="treeData"
               :props="defaultProps"
               @node-click="handleNodeClick"
      ></el-tree>
      <!--      <el-tree-->
      <!--        v-loading="loading"-->
      <!--        ref="treeRef"-->
      <!--        node-key="id"-->
      <!--        :default-expand-all="true"-->
      <!--        :highlight-current='true'-->
      <!--        :expand-on-click-node="false"-->
      <!--        :data="treeData"-->
      <!--        :props="defaultProps"-->
      <!--        @node-click="handleNodeClick"-->
      <!--      ></el-tree>-->
    </div>
    <div class="employees-table">
      <!--      <el-button @click="edit">编辑</el-button>-->
      <page-template
        ref="employees"
        :tableOptions="tableOptions"
        :searchOptions="searchOptions"
        :toolConfig="toolConfig"
      ></page-template>
    </div>
    <add-form ref="addFormOptions" @submit="upgradePwd"></add-form>
    <el-dialog :title="dialogTitle" :visible.sync="infoShow" @close="closeDialog" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label='姓名' prop="name">
              <el-input v-model.trim="form.name" placeholder='请输入' :maxlength="16"
                        @change="this.checkUserName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label='工号' prop="loginName">
              <el-input v-model.trim="form.loginName" @change="checkCode" :maxLength="4" placeholder='请输入'
                        :disabled="isDisabled"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isDisabled?24:12">
            <el-form-item label='手机号' prop="phone">
              <el-input v-model.trim="form.phone" placeholder='请输入' @change="checkPhone" :disabled="isAdmin"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!isDisabled">
            <el-form-item label='登录密码' prop="passwordLogin">
              <el-input v-model.trim="form.passwordLogin" placeholder='请输入' :maxlength="16" type="password"
                        autocomplete="new-password"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label='门店名称' prop="storeId">
              <el-select v-model="form.storeId" placeholder="请选择" @change="storeChange"
                         :disabled="isEdit || isDisabled">
                <el-option
                  v-for="(item,index) in storeIdList"
                  :key="index"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label='角色' prop="roleId">
              <el-select v-model="form.roleId" placeholder="请选择" @change="roleChange" :disabled="isAdmin">
                <el-option
                  v-for="(item,index) in roleList"
                  :key="index"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label='折让限额' prop="highestAllowanceMoney">
              <el-input-number type="number" :min="0" v-model.trim="form.highestAllowanceMoney" :max="99999.99"
                               placeholder='请输入'
                               class="numrule"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label='最低折扣' prop="highestDiscount">
              <el-input type="number" :min="0.0001" :max="1" v-model.trim="form.highestDiscount" placeholder='请输入'
                        style="width: 100px" class="numrule"></el-input>
              <span style="color:#e6a23c;">注:折让范围0.001~1,为空则不限制</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label='第三方编码' prop="relateCode">
              <el-input v-model.trim="form.relateCode" placeholder='请输入' :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label='收银权限' prop="cashierJurisdictionsList">
              <el-checkbox :indeterminate="isIndeterminate1" v-model="checkAll1"
                           @change="handleCheckAllChange($event,1)">全选
              </el-checkbox>
              <el-checkbox-group v-model="form.cashierJurisdictionsList" @change="handleCheckedCitiesChange($event,1)">
                <el-checkbox v-for="(item,index) in cashierJurisdictionsList" :label="item" :key="index">{{ item.name }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label='店管权限' prop="storeJurisdictionsList">
              <el-checkbox :indeterminate="isIndeterminate2" v-model="checkAll2"
                           @change="handleCheckAllChange($event,2)">全选
              </el-checkbox>
              <el-checkbox-group v-model="form.storeJurisdictionsList" @change="handleCheckedCitiesChange($event,2)">
                <el-checkbox v-for="(item,index) in storeJurisdictionsList" :label="item" :key="index">{{ item.name }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="dialog-footer">
          <el-button type="primary" @click="save">提交</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import pageTemplate from '@/components/template/pageTemplate';
import addForm from '@/components/template/add';
import api from '@/config/api';
import userPower from '@/mixin/userPower';

export default {
  mixins: [userPower],
  components: {
    addForm,
    pageTemplate

  },
  data() {
    return {
      storeJurisdictionsList: [], // 管店权限列表
      cashierJurisdictionsList: [], // 收银权限列表
      isIndeterminate1: false, // checkbox 的不确定状态
      isIndeterminate2: false, // checkbox 的不确定状态
      checkAll1: false, // 全选
      checkAll2: false, // 全选
      formType: '',
      editData: {},
      form: {
        name: '',
        loginName: '',
        phone: '',
        relateCode: '',
        storeId: -1,
        roleId: '',
        // password:this.$utils.md5('123456'),
        passwordLogin: '',
        password: '',
        cashierJurisdictionsList: [], // 选择收银权限
        storeJurisdictionsList: [], // 选择管店权限
        type: null,
        highestAllowanceMoney: '', // 折让限额
        highestDiscount: ''// 最低折扣
      },
      isEdit: false,
      isDisabled: false,
      isAdmin: false,
      rules: {
        name: [{required: true, pattern: '^.{2,15}$', message: '请输入姓名，长度在2-15个字符', trigger: 'blur'}],
        passwordLogin: [{required: true, pattern: '^.{6,15}$', message: '请输入6-15位长度密码', trigger: 'blur'}],
        loginName: [{required: true, pattern: '^.{4,4}$', message: '请输入4位长度工号', trigger: 'blur'}],
        phone: [{required: false, pattern: this.$utils.reg.phone, message: '请输入正确手机号', trigger: 'blur'}],
        storeId: [{required: true, message: '请选择门店', trigger: 'change'}],
        roleId: [{required: true, message: '请选择角色', trigger: 'change'}],
        highestDiscount: [{
          required: false,
          pattern: this.$utils.reg.discount,
          message: '请输入0.0001~1之间的值',
          trigger: 'blur'
        }],
        highestAllowanceMoney: [{
          required: false,
          pattern: this.$utils.reg.thanNum,
          message: '请输入非负数',
          trigger: 'blur'
        }]
      },
      storeIdList: [],
      roleList: [],
      infoShow: false,
      dialogTitle: '',
      loading: false,
      treeData: [],
      currentKey: -1, // 默认当前选中第一个 父节点
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      dialogVisibility: false,

      // 高级搜索条件
      searchOptions: {
        simple: [
          // {
          //   label: "门店名称",
          //   type: "select",
          //   prop: "storeId",
          //   span: 12,
          //   data: [],
          //   isHasAll: true,
          //   isHasAllShop: true,//添加‘全部门店’字段
          //   url: api.store.store,
          // },
          {
            label: '工号',
            prop: 'loginName',
            type: 'input',
            ifFuzzy: true,
            placeholder: '请输入姓名/工号'
          }
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: '添加',
          code: 'insert',
          callback: this.add
        },
        {
          label: '删除',
          code: 'delete',
          type: this.$utils.buttonType.tableOperate,
          callback: this.deleteOne
        },
        {
          label: '退出',
          code: 'logout',
          type: this.$utils.buttonType.tableOperate,
          filter: () => {
            return false
          }
        },
        {
          label: '编辑',
          code: 'update',
          type: this.$utils.buttonType.tableOperate,
          callback: this.edit
        },
        {
          label: '修改密码',
          code: 'updatePassword',
          callback: this.updatePassword
        }
      ],
      // 表格信息配置
      tableOptions: {
        indexShow: true, // 是否显示索引
        columns: [
          {
            label: '门店名称',
            prop: 'storeName',
            width: '120',
            align: 'center'
          },
          {
            label: '姓名',
            prop: 'name',
            width: '120',
            align: 'center'
          },
          {
            label: '工号',
            prop: 'loginName',
            width: '120',
            align: 'center'
          },
          {
            label: '手机号',
            prop: 'phone',
            width: '120',
            align: 'center',
            merge: true
          },
          {
            label: '角色',
            type: 'select',
            prop: 'roleName',
            align: 'center'
          }
        ],
        // url: api.system.staffPage,
        param: {}
      },
      // 修改密码
      changePwdDialog: {
        formType: 'other',
        labelWidth: '100px',
        span: 12,
        columns: [
          {
            label: '员工姓名',
            type: 'input',
            prop: 'name',
            disabled: true
          },
          {
            label: '登录用户名',
            type: 'input',
            prop: 'loginName',
            disabled: true
          },
          {
            label: '新密码',
            type: 'password',
            prop: 'newPasswordPlaintext',
            rule: [
              {required: true, message: '请输入密码', trigger: 'blur'},
              {
                min: 6,
                max: 20,
                message: '长度在6到 20个字符',
                trigger: 'blur'
              }
            ]
          },
          {
            label: '确认密码',
            type: 'repassword',
            prop: 'rePassword',
            passwordProp: 'newPasswordPlaintext'
          }
        ],
        url: api.system.account,
        formData: {}
      },
      userInfo: {}
    };
  },
  created() {
    this.userInfo = this.$utils.getSysUser()
    // this.setStore(this.searchOptions.simple);
    this.storeMethod();
    this.getStoreList();
    this.getSysJurisdiction(20);
    this.getSysJurisdiction(40);
  },
  mounted() {
    if (!this.userInfo.storeId) {
      this.tableOptions.param.storeId = -1
      this.$refs['treeRef'].setCurrentKey(this.currentKey)
    }
    this.tableOptions.url = api.system.staffPage
    this.$refs.employees.operationSuccess()// 刷新列表
  },
  methods: {
    // 获取门店
    getStoreList() {
      this.loading = true
      this.$axios.fetchPost(api.store.store + '/list', {}).then(res => {
        if (res.code === 200 && res.data) {
          this.storeIdList = this.$utils.deepClone(res.data)
          this.storeIdList.unshift({id: -1, name: '总部'})
          this.treeData.push({
            id: -1,
            name: '总部',
            // name: this.$utils.getSysUser().merchantName,
            children: res.data
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 权限列表
    getSysJurisdiction(type) {
      this.$axios.fetchPost(api.system.sysJurisdiction, {type}).then((data) => {
        if (data.code == 200 && data.data) {
          if (type == 20) {
            this.storeJurisdictionsList = this.$utils.deepClone(data.data);
          } else {
            this.cashierJurisdictionsList = this.$utils.deepClone(data.data);
          }
        }
      });
    },
    // 点击全选
    handleCheckAllChange(val, type) {
      if (type === 1) {
        this.form.cashierJurisdictionsList = val ? this.cashierJurisdictionsList : [];
        this.isIndeterminate1 = false
      }
      if (type === 2) {
        this.form.storeJurisdictionsList = val ? this.storeJurisdictionsList : [];
        this.isIndeterminate2 = false
      }
    },
    // 部分选择
    handleCheckedCitiesChange(value, type) {
      let checkedCount = value.length;
      if (type === 1) {
        this.checkAll1 = checkedCount === this.cashierJurisdictionsList.length;
        this.isIndeterminate1 = checkedCount > 0 && checkedCount < this.cashierJurisdictionsList.length;
      }
      if (type === 2) {
        this.checkAll2 = checkedCount === this.storeJurisdictionsList.length;
        this.isIndeterminate2 = checkedCount > 0 && checkedCount < this.storeJurisdictionsList.length;
      }
    },
    add() {
      this.dialogTitle = '新增用户'
      this.formType = '新增'
      this.form.highestAllowanceMoney = 0;
      this.form.highestDiscount = 1;
      this.infoShow = true
      this.storeMethod();
    },
    edit(row) {
      this.dialogTitle = '编辑用户'
      this.formType = '编辑'
      this.infoShow = true
      this.isDisabled = true
      this.getDetail(row.id)
    },
    // 删除
    deleteOne(row) {
      this.$confirm('确定要删除此用户吗？')
        .then(_ => {
          this.$axios.fetchDelete(api.system.sysUser + '?id=' + row.id).then(res => {
            if (res.code === 200) {
              this.$notify({
                type: "success",
                title: '删除操作',
                message: '成功',
                showClose: false,
              });
              // this.$message.success('删除成功')
              this.$refs.employees.operationSuccess()// 刷新列表
            } else {
              this.$notify({
                type: "error",
                title: '删除操作',
                message: '失败',
                showClose: false,
              });
              // this.$message.error('删除错误')
            }
          })
        })
        .catch(_ => {
        });
    },
    // 提交 新增用户信息
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '提交中，请稍候...',
            background: 'rgba(225, 225, 225, 0.8)'
          });
          if (this.formType == '新增') {
            this.form.password = this.$utils.md5(this.form.passwordLogin)
            this.$axios.fetchPost(api.system.sysUserAdd, this.form).then(res => {
              if (res.code === 200) {
                if (res.data) {
                  this.$notify({
                    type: "success",
                    title: '新增操作',
                    message: '成功',
                    showClose: false,
                  });
                  // this.$message.success('保存成功')
                  this.tableOptions.param.storeId = this.form.storeId
                  this.$refs.employees.operationSuccess()
                  this.closeDialog()
                }
              } else {
                this.$notify({
                  type: "error",
                  title: '新增操作',
                  message: res.errorMsg || '失败',
                  showClose: false,
                });
                // this.$message({type: 'error', message: res.msg});
              }
            }).catch(err => {
            }).finally(() => {
              loading.close()
            })
          } else {
            this.$axios.fetchPut(api.system.sysUser, this.form).then(res => {
              if (res.code === 200) {
                if (res.data) {
                  this.$notify({
                    type: "success",
                    title: '修改操作',
                    message: '成功',
                    showClose: false,
                  });
                  // this.$message.success('保存成功')
                  this.tableOptions.param.storeId = this.form.storeId
                  this.$refs.employees.operationSuccess()
                  this.closeDialog()
                }
              } else {
                this.$notify({
                  type: "error",
                  title: '修改操作',
                  message: res.errorMsg || '失败',
                  showClose: false,
                });
                // this.$message({type: 'error', message: res.msg});
              }
            }).catch(err => {
            }).finally(() => {
              loading.close()
            })
          }
        } else {
          return false
        }
      })
    },
    // 验重方法
    checkFun(val, url, message) {
      return new Promise((resolve, reject) => {
        this.$axios.fetchGet(url + val).then(res => {
          if (res.code == 200) {
            if (!res.data) {
              this.$message({type: 'warning', message: message + '，请重新输入'});
              this.isReaptName = false
            } else {
              this.isReaptName = true
            }
            resolve(this.isReaptName)
          } else {
            reject()
            this.$message({type: 'error', message: res.msg});
          }
        })
          .catch(err => {
          })
      })
    },
    // 工号验重
    checkCode() {
      console.log(this.form.loginName);
      this.checkFun(this.form.loginName, api.system.sysUser + '/check/login/name?loginName=', '工号重复').then((data) => {
        if (!data) {
          if (this.formType === '新增') {
            this.form.loginName = ''
          }
          if (this.formType === '编辑') {
            this.form.loginName = this.oldData.loginName
          }
        }
      })
    },
    // 电话验重
    checkPhone() {
      this.checkFun(this.form.phone, api.system.sysUser + '/verify/phone?phone=', '电话号码重复').then((data) => {
        if (!data) {
          if (this.formType === '新增') {
            this.form.phone = ''
          }
          if (this.formType === '编辑') {
            this.form.phone = this.oldData.phone
          }
        }
      })
    },
    // 商品详情
    getDetail(id) {
      this.$axios.fetchGet(api.system.sysUserGet + '?id=' + id, {}).then(res => {
        if (res.code === 200) {
          if (res.data) {
            this.editData = this.$utils.deepClone(res.data);
            let arr1 = []
            let arr2 = []
            this.oldData = this.$utils.deepClone(res.data)
            if (res.data.loginName == 1001) {
              this.isAdmin = true
            }
            // 回显角色
            this.storeChange(res.data.storeId, true)
            // 回显权限
            if (res.data.storeJurisdictionsList && res.data.storeJurisdictionsList.length > 0) {
              res.data.storeJurisdictionsList.forEach(item => {
                this.storeJurisdictionsList.forEach(v => {
                  if (v.id == item) {
                    arr1.push(v)
                  }
                })
              })
            }
            if (res.data.cashierJurisdictionsList && res.data.cashierJurisdictionsList.length > 0) {
              res.data.cashierJurisdictionsList.forEach(item => {
                this.cashierJurisdictionsList.forEach(v => {
                  if (v.id == item) {
                    arr2.push(v)
                  }
                })
              })
            }
            this.form = res.data
            if (!res.data.highestAllowanceMoney) {
              this.form.highestAllowanceMoney = 0;
            }
            if (!res.data.highestDiscount) {
              this.form.highestDiscount = 1;
            }
            this.form.storeJurisdictionsList = arr1
            this.form.cashierJurisdictionsList = arr2
            // 全选状态回显
            this.handleCheckedCitiesChange(this.form.cashierJurisdictionsList, 1)
            this.handleCheckedCitiesChange(this.form.storeJurisdictionsList, 2)
          }
        } else {
          this.$message({type: 'error', message: res.errorMsg});
        }
      }).catch(err => {
      })
    },
    // 关闭新增用户
    closeDialog() {
      this.infoShow = false
      this.isDisabled = false
      this.isAdmin = false
      this.roleList = []
      this.isIndeterminate1 = false// checkbox 的不确定状态
      this.isIndeterminate2 = false// checkbox 的不确定状态
      this.checkAll1 = false// 全选
      this.checkAll2 = false// 全选
      this.$refs.form.resetFields()
      this.form = {
        name: '',
        loginName: '',
        phone: '',
        storeId: this.nodeStoreId ? this.nodeStoreId : -1,
        roleId: '',
        password: '',
        passwordLogin: '',
        cashierJurisdictionsList: [], // 选择收银权限
        storeJurisdictionsList: [], // 选择管店权限
        type: null,
        highestAllowanceMoney: '', // 折让限额
        highestDiscount: ''// 最低折扣
      }
    },

    // 点击门店
    handleNodeClick(data) {
      console.log(data);
      this.tableOptions.param.storeId = data.id
      this.nodeStoreId = data.id
      this.form.storeId = data.id
      this.tableOptions.url = api.system.staffPage
      this.$refs.employees.operationSuccess()
    },
    storeMethod() {
      if (this.userInfo.storeId) {
        // let storeId = this.addColumns.columns.filter((item) => item.prop === "storeId")[0];
        // storeId.disabled = true;
        // storeId.defaultValue = userInfo.storeId;
        this.isEdit = true
        this.form.storeId = this.userInfo.storeId;
        this.storeChange(this.userInfo.storeId);
      } else {
        this.storeChange(this.form.storeId);
      }
    },
    // 选择门店
    storeChange(val, type) {
      this.roleList = []
      if (!type) {
        this.form.roleId = ''
      }
      this.$axios.fetchPost(api.system.sysRole, {storeId: val}).then(data => {
        if (data.code === 200 && data.data) {
          this.roleList = data.data;
        } else {
          this.$message({message: '请求失败', type: 'error'})
        }
      })
      // 校验用户名
      this.checkUserName();
    },
    // 选择角色
    roleChange(val) {
      let result = this.roleList.filter(v => v.id === val)[0]
      console.log(result)
      this.form.type = result.roleType
    },
    updatePassword(row) {
      this.changePwdDialog.formData = row;
      this.$nextTick(() => {
        // this.addColumns && this.$store.commit(this.$utils.storeKeys.OTHERFORM, this.changePwdDialog);
        this.$store.commit(this.$utils.storeKeys.OTHERFORM, this.changePwdDialog);
        this.$refs['addFormOptions'].setFormOptions('other', row.id, '修改密码');
      })
    },
    upgradePwd(data) {
      let params = {id: data.id, newPassword: data.newPassword};
      this.$axios.fetchPost(api.system.account + '/password' + `?${this.$utils.JSONToString(params)}`, {}).then(result => {
        if (result.code === 200) {
          this.$notify({
            type: "success",
            title: '修改操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({type: 'success', message: '修改成功!'});
        } else {
          this.$message({type: 'error', message: result.msg});
        }
      }).catch(err => {
        this.$notify({
          type: "error",
          title: '修改操作',
          message: '失败',
          showClose: false,
        });
        // this.$message({type: 'error', message: '修改失败!'});
      })
    },
    checkUserName() {
      // 校验门店用户名是否重复
      let form = this.form;
      if (this.editData) {
        if (this.editData.name === form.name) {
          this.editData = {};
          return;
        }
      }
      if (form.name === '管理员') {
        form.name = '';
        this.$message({type: 'warning', message: '添加用户名称不能为【管理员】'});
        return;
      }
      if (!form.storeId) {
        this.$message({type: 'warning', message: '请先选择门店'});
      } else {
        this.$axios.fetchPost(api.system.account + '/check/user/name', form).then(data => {
          if (data.code === 200) {
            if (data.data === false) {
              form.name = '';
              this.$message({type: 'warning', message: '用户名称已存在'});
            }
          } else {
            this.$message({type: 'error', message: '请求失败'})
          }
        })
      }
    }
  }
};
</script>
<style scoped>
  .employees-container {
    width: 100%;
    height: 100%;
    display: flex;
  }

  .employees-tree {
    height: 100%;
    min-width: 20%;
    padding: 16px;
    overflow: scroll;
  }

  .employees-table {
    flex: 1;
    /*padding:0 10px 10px 10px;*/
  }

  /*去掉箭头*/
  /deep/ .numrule input::-webkit-outer-spin-button,
  /deep/ .numrule input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }

  /deep/ .numrule input[type="number"] {
    -moz-appearance: textfield;
  }
</style>



// WEBPACK FOOTER //
// src/page/system/user/staff.vue